import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-gold">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-primary-blue mb-4">
          Need Legal Assistance?
        </h2>
        <p className="text-xl text-primary-blue mb-8">
          Get in touch with our expert legal team for a free consultation.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center bg-primary-blue hover:bg-secondary-blue text-white font-semibold py-4 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 group"
          >
            Schedule Consultation
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="tel:+919769415432"
            className="inline-flex items-center justify-center bg-white hover:bg-gray-100 text-primary-blue font-semibold py-4 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 group"
          >
            <Phone className="w-5 h-5 mr-2" />
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;